import styled from "styled-components";
import { InfoCircleOutlined, CaretUpOutlined } from "@ant-design/icons";
import { TEAL } from "../../EmployeeSkillsBridgerV2.constants";
import { SB_COLORS } from "theme/SbThemeV2";

// ─── Layout ───────────────────────────────────────────────────────────────────

export const TitleWrapperStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const LegendRowStyled = styled.div`
  display: flex;
  align-items: center;
  gap: 3px;
  margin-top: 4px;
`;

export const LegendCaretIconStyled = styled(CaretUpOutlined)`
  color: ${TEAL};
  font-size: 14px;
  flex-shrink: 0;
`;

// ─── Popover title ────────────────────────────────────────────────────────────

export const PopoverTitleWrapperStyled = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: ${({ theme }) => theme.colors.secondary};
  border-radius: 6px 6px 0 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};
`;

export const PopoverTitleIconStyled = styled(InfoCircleOutlined)`
  color: ${TEAL};
  font-size: 18px;
  flex-shrink: 0;
`;

export const PopoverTitleTextStyled = styled.span`
  color: ${TEAL};
  font-weight: 600;
`;

// ─── Popover content ──────────────────────────────────────────────────────────

export const PopoverContentStyled = styled.div`
  color: #595959;
  line-height: 1.6;
  padding: 12px 16px;
`;

// ─── Trigger icon ─────────────────────────────────────────────────────────────

export const PopoverTriggerIconStyled = styled(InfoCircleOutlined)`
  color: ${TEAL};
  font-size: 18px;
  cursor: pointer;
  margin-left: 8px;
`;

// ─── Antd Popover style config (passed to antd `styles` prop) ─────────────────

export const POPOVER_STYLES_CONFIG = {
  root: { width: 640 },
  body: {
    border: `2px solid ${TEAL}`,
    borderRadius: 8,
    background: SB_COLORS.secondary,
    padding: 0,
  },
};
